import React, { FC } from 'react';
import classNames from 'classnames';

import('../../../assets/svg/sprite.svg');

import css from './style.module.scss';

interface IProps {
  id: string;
  className?: string;
  [restProps: string]: any;
}

const Icon: FC<IProps> = ({ id, className, ...restProps }) => (
  <svg className={classNames(css.svg, className)} {...restProps}>
    <use xlinkHref={`#sprite_${id}`} />
  </svg>
);

export default Icon;
